var _rect, _rect2, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#3C2190",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#F6F5F8",
    strokeOpacity: 0.8
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25875_12138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 27,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5H31V31.5H4V4.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25875_12138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8097 16.0761L19.4247 13.6912C19.2144 13.4808 19.0962 13.1955 19.0962 12.898C19.0962 12.7507 19.1252 12.6049 19.1816 12.4688C19.238 12.3327 19.3206 12.2091 19.4247 12.1049C19.5289 12.0007 19.6525 11.9181 19.7886 11.8618C19.9247 11.8054 20.0706 11.7764 20.2179 11.7764C20.5153 11.7764 20.8006 11.8946 21.011 12.1049L22.5972 13.6912L26.5797 9.70865C26.7901 9.4983 27.0754 9.38013 27.3729 9.38013C27.6703 9.38013 27.9556 9.4983 28.166 9.70865C28.3763 9.919 28.4945 10.2043 28.4945 10.5018C28.4945 10.7993 28.3763 11.0846 28.166 11.2949L23.396 16.0649C22.9572 16.5149 22.2485 16.5149 21.8097 16.0761ZM15.251 12.3749H7.37598C6.75723 12.3749 6.25098 12.8812 6.25098 13.4999C6.25098 14.1187 6.75723 14.6249 7.37598 14.6249H15.251C15.8697 14.6249 16.376 14.1187 16.376 13.4999C16.376 12.8812 15.8697 12.3749 15.251 12.3749ZM26.8272 18.7987C26.7232 18.6944 26.5995 18.6116 26.4634 18.5552C26.3273 18.4987 26.1814 18.4697 26.0341 18.4697C25.8868 18.4697 25.7409 18.4987 25.6048 18.5552C25.4687 18.6116 25.3451 18.6944 25.241 18.7987L23.126 20.9137L21.011 18.7987C20.8006 18.5883 20.5153 18.4701 20.2179 18.4701C19.9204 18.4701 19.6351 18.5883 19.4247 18.7987C19.2144 19.009 19.0962 19.2943 19.0962 19.5918C19.0962 19.8893 19.2144 20.1746 19.4247 20.3849L21.5397 22.4999L19.4247 24.6149C19.3206 24.7191 19.238 24.8427 19.1816 24.9788C19.1252 25.1149 19.0962 25.2607 19.0962 25.408C19.0962 25.5553 19.1252 25.7012 19.1816 25.8373C19.238 25.9733 19.3206 26.097 19.4247 26.2012C19.6351 26.4115 19.9204 26.5297 20.2179 26.5297C20.3651 26.5297 20.511 26.5007 20.6471 26.4443C20.7832 26.3879 20.9068 26.3053 21.011 26.2012L23.126 24.0862L25.241 26.2012C25.4513 26.4115 25.7366 26.5297 26.0341 26.5297C26.3316 26.5297 26.6169 26.4115 26.8272 26.2012C27.0376 25.9908 27.1557 25.7055 27.1557 25.408C27.1557 25.1105 27.0376 24.8252 26.8272 24.6149L24.7122 22.4999L26.8272 20.3849C26.9315 20.2808 27.0143 20.1572 27.0707 20.0211C27.1272 19.885 27.1562 19.7391 27.1562 19.5918C27.1562 19.4444 27.1272 19.2985 27.0707 19.1624C27.0143 19.0264 26.9315 18.9027 26.8272 18.7987ZM15.251 21.3749H7.37598C6.75723 21.3749 6.25098 21.8812 6.25098 22.4999C6.25098 23.1187 6.75723 23.6249 7.37598 23.6249H15.251C15.8697 23.6249 16.376 23.1187 16.376 22.4999C16.376 21.8812 15.8697 21.3749 15.251 21.3749Z",
    fill: "#F6F5F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.950441b218f4c3f71825ce77a543c4f3.svg";
export { ForwardRef as ReactComponent };